export const downloadURL = process.env.REACT_APP_DOWNLOAD_URL;
export const callMeURL = process.env.REACT_APP_CALL_URL;
export const launchProtocol = process.env.REACT_APP_LAUNCH_PROTOCOL;
export const localhostDNS = process.env.REACT_APP_LOCALHOST_DNS;
export const webAppURI = process.env.REACT_APP_WEB_APP_URI;
export const launcherAppURI = process.env.REACT_APP_LAUNCHER_APP_URI;
export const START_ROUTE = '/start';
export const LIFESIZE_RESPONSE_SUCCESS = "LIFESIZE";
export const SKIP_DOWNLOAD_FOR_TEST = "skipDownloadForTest";
